<!-- 插图组件 -->
<template>
  <vue-draggable-resizable :draggable="!locked" :h="height" :minHeight="30" :minWidth="30" :resizable="!locked"
                           :w="width"
                           :x="x" :y="y"
                           :z="index" @activated="activated=true" @deactivated="activated=false" @dragging="onDrag"
                           @dragstop="onStop"
                           @resizestop="onStop" @resizing="onResize"
                           style="border: 0">
    <div class="insert-pic">
      <el-tooltip content="双击配置插图" effect="dark" placement="right">
        <div class="pic-main">
          <div @dblclick="handleCmp('config',  componentIndex)" style="width: 100%;height: 100%">
            <el-image :src="src" fit="fill" style="width: 100%;height: 100%">
              <div class="image-slot" slot="placeholder">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
        </div>
      </el-tooltip>
      <el-dialog :append-to-body="true"
                 :show-close="false"
                 :title="'插图配置'"
                 :visible.sync="showConfig"
                 style="padding-top: 0"
                 top="20vh"
                 width="600px">
        <el-row>
          <el-select placeholder="选择图片" size="small" style="width: 200px" v-model="currentPic">
            <el-option
              :key="item.url"
              :label="item.name"
              :value="item.url"
              v-for="item in fileList">
            </el-option>
          </el-select>
          <el-button @click="handleCmp('delete',  componentIndex)" size="small" style="float: right;margin-left: 10px"
                     type="danger">删除组件
          </el-button>
          <el-button @click="managePic" size="small" style="float: right" type="primary">管理图片</el-button>
          <el-checkbox style="margin-left: 20px" v-model="onTop">置顶</el-checkbox>
          <el-checkbox v-model="locked">锁定</el-checkbox>
        </el-row>
        <div class="dialog-footer" slot="footer">
          <el-button @click="cancelSet">取 消</el-button>
          <el-button @click="valueConfirm" type="primary">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :append-to-body="true"
        :show-close="false"
        :title="'图片集管理'"
        :visible.sync="showPicConfig"
        style="padding-top:0"
        top="20vh"
        width="600px">
        <el-upload
          :file-list="fileList"
          :http-request="uploadPic"
          action="/"
          list-type="picture"
          ref="uploadFileCmp">
          <div style="display:flex;float: right;width: 100%">
            <el-button size="small" type="primary">上传图片</el-button>
            <div class="el-upload__tip" slot="tip" style="margin-left: 20px">只能上传jpg/png文件，且不超过500kb</div>
          </div>
        </el-upload>
        <div class="dialog-footer" slot="footer">
          <el-button @click="confirmPic" type="primary">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </vue-draggable-resizable>
</template>

<script>
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import componentApi from '@/api/component';

export default {
  name: 'insert-pic',
  data() {
    return {
      width: 768,
      height: 432,
      x: 0,
      y: 0,
      onTop: false,
      locked: false,
      showConfig: false,
      showPicConfig: false,
      activated: false,
      currentPic: '',
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      fileList: [],
    };
  },
  props: {
    // 当前组件的编号
    componentIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('Engineering', ['dragTreeNodeType']),
    ...mapGetters('Engineering', ['getPanelData_cg']),
    resizekey() {
      return this.$store.state.Engineering.echartResizeKey;
    },
    uploadFiles() {
      return this.$refs.uploadFileCmp.uploadFiles;
    },
    componentId() {
      return this.getPanelData_cg[this.componentIndex].cid;
    },
    index() {
      return this.onTop === true ? 999 : 1;
    },
    config() {
      let config = '';
      config += `${this.width}|`;
      config += `${this.height}|`;
      config += `${this.x}|`;
      config += `${this.y}|`;
      config += `${this.onTop}|`;
      config += `${this.locked}|`;
      config += `${this.currentPic}`;
      return config;
    },
  },
  watch: {
    activated() {
      const _this = this;
      document.onkeydown = function (e) {
        const _key = window.event.keyCode;
        // 删除键删除组件
        if (_key === 46 && _this.activated === true) {
          _this.handleCmp('delete', _this.componentIndex);
        }
      };
    },
  },
  mounted() {
    this.getPictureConfig();
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['setAnchorPointId', 'setAnchorPointId', 'addSingnalToDashboaord']),
    getFileList() {
      componentApi.getPictureInfos(this.componentId)
        .then((res) => {
          this.fileList = res;
          // 仅用于Dev环境
          if (process.env.NODE_ENV === 'development') {
            console.log('当前为开发环境');
            this.fileList.map((file) => {
              file.url = `http://blackbox.focusintec.com${file.url}`;
            });
          }
        })
        .catch(err => console.log(err));
    },
    managePic() {
      this.showConfig = false;
      this.showPicConfig = true;
    },
    valueConfirm() {
      if (this.currentPic === '') {
        this.src = 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg';
      } else {
        this.src = this.currentPic;
      }
      this.savePictureConfig();
      this.showConfig = false;
    },
    cancelSet() {
      this.showConfig = false;
    },
    confirmPic() {
      this.showPicConfig = false;
      this.showConfig = true;
      this.savePictureInfos();
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorPointId(str2);
    },
    handleCmp(command, index) {
      switch (command) {
        case 'delete':
          this.showConfig = false;
          this.$confirm('确定删除插图组件？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // 确认删除
              this.deleteCpt({ index });
            }).then(() => {
              this.$message({
                message: '删除成功！',
              });
            })
            .catch((err) => {
            });
          break;
        case 'config':
          this.getFileList();
          this.showConfig = true;
          break;
        default:
          break;
      }
    },
    handleExceed() {
      this.$message.warning('最多上传一张图片');
    },
    /**
             * 文件上传至服务器
             * */
    uploadPic(uploadComponent) {
      componentApi.uploadPic(uploadComponent.file, this.componentId)
        .then(() => {
          this.$message.success(`正在上传${uploadComponent.file.name},请稍候`);
        })
        .catch((err) => {
          if (this.$refs.uploadFileCmp) {
            this.$refs.uploadFileCmp.clearFiles();
          }
          this.getFileList();
          this.$message({
            type: 'error',
            message: `图片上传失败(${err[0]})：${err[1]}`,
          });
        });
    },
    savePictureInfos() {
      const pictures = [];
      if (this.uploadFiles !== undefined) {
        this.uploadFiles.map((item) => {
          pictures.push(item.name);
        });
        componentApi.savePictureInfos(this.componentId, JSON.stringify(pictures)).then(() => {
          this.getFileList();
        });
      }
    },
    savePictureConfig() {
      componentApi.savePictureConfig(this.componentId, this.config);
    },
    getPictureConfig() {
      if (this.componentId) {
        componentApi.getPictureConfig(this.componentId)
          .then((res) => {
            if (res !== undefined) {
              const configArr = res.split('|');
              this.width = parseInt(configArr[0], 10);
              this.height = parseInt(configArr[1], 10);
              this.x = parseInt(configArr[2], 10);
              this.y = parseInt(configArr[3], 10);
              this.onTop = JSON.parse(configArr[4]);
              this.locked = JSON.parse(configArr[5]);
              this.currentPic = configArr[6];
              this.valueConfirm();
            }
          });
      }
    },
    onResize(x, y, width, height) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
    },
    onDrag(x, y) {
      this.x = x;
      this.y = y;
    },
    onStop(x, y) {
      if (this.x + this.width <= 20) {
        this.x = (this.width * (-1)) + 20;
      }
      if (this.y + this.height <= 20) {
        this.y = (this.height * (-1)) + 20;
      }
      this.savePictureConfig();
    },
  },
};

</script>

<style lang="scss">
  @import "../../style/mixin";

  .insert-pic {
    width: 100%;
    height: 100%;
    background: #ffffff;
    overflow: hidden;

    .pic-main {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/InsertPic.vue